import { getFragment } from '../../graphql';
import type { MailOrderProviderInfoFragment } from '../../graphql/generated/graphql';

/**
 * Gets the appropriate delivery time display for a mail order provider.
 * If a shipping method is specified, returns the delivery time for that specific shipping option.
 * Otherwise, returns the provider's default delivery time display.
 *
 * @param provider - The mail order provider
 * @param shippingMethod - Optional shipping method to match against shipping options
 * @returns The delivery time display string, or undefined if not available
 */
export const getDeliveryTimeDisplay = (
    provider: MailOrderProviderInfoFragment,
    shippingMethod?: string
): string | null | undefined => {
    // If a specific shipping method is provided, find the matching shipping option
    if (shippingMethod && provider.shippingOptions?.length > 0) {
        const matchingOption = provider.shippingOptions.find(
            (option) =>
                getFragment(option).name.toLowerCase() ===
                shippingMethod.toLowerCase()
        );

        if (matchingOption) {
            return getFragment(matchingOption).deliveryTimeDisplay;
        }
    }

    // Fall back to provider's default delivery time
    return provider.deliveryTimeDisplay;
};
